import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import {  Collapse, Button } from "@mui/material";
import steve from "../../../assets/team/steve.jpg";
import edna from "../../../assets/team/edna.png";
import lekan from "../../../assets/team/lekan.png";

const data = [
  {
    imgpath: steve,
    name: "Steve Okeleji",
    title: "Executive Director",
    description:
      "Steve Okeleji is a visionary leader and advocate for the transformation of blue food systems, with a special focus on sustainability, innovation, and community empowerment. Through his remarkable work in the aquaculture and fisheries sectors, Steve...",
    detail1:
      "Steve Okeleji, born to a veterinarian father with a large commercial farm, gained early agricultural experience and began his journey in aquaculture during his second year in 2006 while studying Aquaculture and Fisheries Management at the Federal University of Agriculture in Ogun State, Nigeria, he founded Fish Shoal Nigeria. Later, as a scholar at the Netherlands Business School, Steve was recognized as the African Champion for Agricultural Development in 2021 by African Impact in Accra, Ghana, and currently serves as a member of the United Nations Private Sector Advisory Group.",
    detail2:
      "Steve Okeleji is a visionary leader dedicated to transforming blue food systems with a strong focus on sustainability, innovation, and community empowerment. Through his extensive work in aquaculture and fisheries, he has played a pivotal role in promoting sustainable management of aquatic resources while addressing food security, economic development, and environmental conservation.",
    detail3:
      "A defining achievement in Steve's career is his commitment to empowering women in the blue economy. Recognizing their crucial roles in fisheries and aquaculture—from fish farming to processing and marketing—Steve has implemented programs that provide women with training, financial resources, and access to technology. These efforts have significantly improved livelihoods in coastal and rural communities, positioning women as key contributors to local economies. By integrating women into the blue food value chain, Steve advances gender equality and fosters resilient, inclusive food systems.",
    detail4:
      "Steve’s work is also characterized by his innovative approach to aquaculture, where he has developed sustainable practices that minimize environmental impact while boosting productivity. He has pioneered eco-friendly technologies like integrated multi-trophic aquaculture (IMTA) systems, which reduce waste and enhance biodiversity in aquatic farming. His sustainable aquaculture initiatives set a high standard for balancing environmental responsibility with economic growth. Through partnerships with governments, NGOs, and local communities, Steve Okeleji continues to shape policies and educate others on the importance of healthy oceans and waterways. His leadership in advancing sustainable blue food systems has earned him recognition as a global champion for aquaculture, climate action, and food security.",
  },
  {
    imgpath: edna,
    name: "Edna Eligado Dionisio",
    title: "Technical Adviser",
    description:
      "Distinguished aquaculture expert and fish geneticist with global industry experience for over 30 years in 5 continents of technical experience in fresh and marine fish species across multiple continents. Edna currently functions as our Technical Director.",
    // description:
    //   "Edna is a highly accomplished professional with over 33 years of expertise in aquaculture and fisheries. She has held cross-functional roles, including technical farm management, business strategy, and research, with a strong focus on driving corporate goals through strategic initiatives.",
    detail1:
      "Edna Eligado Dionisio is a highly accomplished professional with over 33 years of expertise in aquaculture and fisheries. She has held cross-functional roles, including technical farm management, business strategy, and research, with a strong focus on driving corporate goals through strategic initiatives. Edna holds a Master’s Degree in Aquaculture, with specialized knowledge in fish breeding and genetics. ",
    detail2:
      "As an international trainer and resource speaker, Edna has contributed to numerous conferences and training programs on aquaculture, fisheries, and genetics research. Recognized as an exceptional aquaculture specialist, she has worked with major organizations across Asia and Africa, focusing on research, development, and commercial fish hatchery operations, managing both freshwater and marine fish species.",
    detail3:
      "A pioneer in aquaculture research, Edna played a key role in the Genetic Improvement of Farmed Tilapia (GIFT) project, a groundbreaking 10-year collaborative research initiative led by the International Center for Living Aquatic Resources Management (ICLARM), now the World Fish Center (WFC). This multi-million-dollar project, funded by the Asian Development Bank (ADB) and the United Nations Development Programme (UNDP), was conducted in partnership with renowned institutions such as the Bureau of Fisheries and Aquatic Resources (BFAR), the University of the Philippines Marine Science Institute, and Aquaculture Research Norway (AKVAFORSK). The project made significant advancements in tilapia genetics and set new standards for sustainable aquaculture practices. Throughout her career, Edna has been recognized for her outstanding contributions to the field, earning multiple awards, including the prestigious 'Woman in Aquaculture’ recognition. Her expertise has attracted numerous organizations to collaborate with her on high-impact aquaculture initiatives.",
    detail4:
      "Currently, Edna serves as the Technical Director for the Blue-Echo Foundation, bringing her extensive experience in aquaculture management, fish genetics, and sustainable development to the organization's climate change advocacy and blue economy initiatives. She also holds the position of Technical Director-Fish Business at the Aquatic Afrique Hub Network (AHAN), where she continues to lead efforts in promoting sustainable aquaculture practices in emerging economies.",
  },
  {
    imgpath: lekan,
    name: "Olalekan Adeleke",
    title: "Programs and Project Director.",
    description:
      "Olalekan Hadrian Adeleke is a dynamic and smart professional who has been at the center of programs and project planning and delivery for the organization. Olalekan currently functions as our Programs and Project Director.",
    detail1:
      "Olalekan Hadrian Adeleke is a dynamic and smart professional who has been at the center of programs and project planning and delivery for the organization. Olalekan currently functions as our Programs and Project Director at the Blue-Echo Foundation, the non-profit arm of Aquatic Hub Afrique Network, Olalekan spearheads initiatives that focus on empowering coastal communities through sustainable aquaculture and environmental conservation.",
    detail2:
      "Under his leadership, Blue-Echo Foundation has pioneered programs that support the adoption of eco-friendly aquaculture practices across West Africa, emphasizing the use of offshore cage systems for fish farming. These systems, developed using locally sourced materials, have reduced the reliance on fossil fuels by 90%, drastically cutting production costs and reducing environmental impact. Olalekan is a two-time delegate to the Global Sustainable Development Congress and has collaborated with several other sustainability champions across the globe; he works closely with local fish farmers, government agencies, and international partners to promote sustainable fisheries, support capacity-building programs, and foster resilient communities.",
    detail3:
      "A graduate of the Federal University of Technology Akure, with a degree in Statistics, Olalekan has further honed his leadership skills through international certifications, including the Leading with Emotional Intelligence course at Case Western Reserve University, U.S.A. and a Fellowship with the Africa Drone and Data Academy. He also holds an MBA from Nexford University, Washington D.C., and was recently accepted into the M.Sc. in Project Management program of the European International University (EIU-PARIS), reflecting his dedication to continuous personal and professional growth.",
    detail4:
      "Olalekan’s diverse experience spans the media, health, agriculture, and capacity-building sectors, bringing a unique interdisciplinary approach to his work. As a passionate advocate for youth empowerment, he has designed and implemented programs for over 30,000 young people across Nigeria, nurturing a new generation of leaders in sustainable aquaculture and environmental stewardship. As an active member of Junior Chamber International since 2012, Olalekan has held various leadership roles, including being a founding member of JCI Abeokuta Hills and will also be leading the organization in 2025 as Local Organization President. He was awarded the status of JCI Nigeria Ambassador in 2021, underscoring his commitment to civic leadership and community development.",
  },
];

const Management = () => {
  // Track open/close state for each profile
  const [expanded, setExpanded] = useState(Array(data.length).fill(false));

  const handleExpandClick = (index) => {
    const newExpanded = [...expanded];
    newExpanded[index] = !newExpanded[index];
    setExpanded(newExpanded);
  };

  return (
    <Box margin={{ xs: "5% 0%", sm: "0% 0% 10% 0%" }}>
      <Grid container spacing={1}>
        {data.map((list, index) => {
          const {
            imgpath,
            name,
            title,
            description,
            detail1,
            detail2,
            detail3,
            detail4,
          } = list;
          return (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              marginTop={{ xs: "5%", sm: "3%" }}
              key={index}
            >
              <Card sx={{ maxWidth: 360, height: "100%" }}>
          
                  <CardMedia
                    component="img"
                    height="340"
                    image={imgpath}
                    sx={{ objectFit: "cover" }}
                    alt={name}
                  />
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h5"
                      color={"#317ABE"}
                      component="div"
                      fontWeight={700}
                      paddingBottom={"1%"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      paddingBottom={"2%"}
                      variant="body2"
                      color="#9DCC49"
                      fontWeight={700}
                    >
                      {title}
                    </Typography>
                    {!expanded[index] && (
                      <Typography paddingBottom={"5%"} variant="body1">
                        {description}
                      </Typography>
                    )}

                    {/* Collapse Toggle Button */}
                    <Button
                      onClick={() => handleExpandClick(index)}
                      variant="text"
                      sx={{
                        color: "#317ABE",
                        fontWeight: 700,
                        "&:hover": { color: "#9DCC49" },
                      }}
                    >
                      {expanded[index] ? "Read Less" : "Read More"}
                    </Button>

                    {/* Collapse Detail Section */}
                    <Collapse in={expanded[index]} timeout="auto" unmountOnExit>
                      <Typography variant="body1" paddingTop={"2%"}>
                        {detail1}
                      </Typography>
                      <Typography variant="body1" paddingTop={"3%"}>
                        {detail2}
                      </Typography>
                      <Typography variant="body1" paddingTop={"3%"}>
                        {detail3}
                      </Typography>
                      <Typography variant="body1" paddingTop={"3%"}>
                        {detail4}
                      </Typography>
                    </Collapse>
                  </CardContent>
    
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Management;
